import React from "react";
import Main from "../src/components/Layout/Main";
import "antd/dist/antd.css";
import "./App.css";

function App() {
  return <Main />;
}

export default App;
